import { pickLocalizedText, type LocalizedText } from './uiLocale'

const copy = {
  selection: { es: 'Selección', en: 'Selection' },
  seat: { es: 'Asiento', en: 'Seat' },
  arm: { es: 'Brazo', en: 'Arm' },
  arms: { es: 'Brazos', en: 'Arms' },
  armSingular: { es: 'brazo', en: 'arm' },
  armPlural: { es: 'brazos', en: 'arms' },
  refPrefix: { es: 'Ref.', en: 'Ref.' },
  chooseModules: { es: 'Elegir módulos', en: 'Choose modules' },
  chooseFabricAndColor: { es: 'Elegir tejido y color', en: 'Choose fabric and color' },
  backToPrincipal: { es: 'Volver a Principal', en: 'Back to Main' },
  backToMainMenu: { es: 'Volver al menú principal', en: 'Back to main menu' },
  searchByWidth: { es: 'Buscar por ancho...', en: 'Search by width...' },
  search: { es: 'Buscar...', en: 'Search...' },
  searchingModules: { es: 'Buscando módulos...', en: 'Searching modules...' },
  noResultsFound: { es: 'No se encontraron resultados', en: 'No results found' },
  showDimensions: { es: 'Mostrar cotas', en: 'Show dimensions' },
  hideDimensions: { es: 'Ocultar cotas', en: 'Hide dimensions' },
  saveProject: { es: 'Guardar el proyecto', en: 'Save project' },
  createNewProject: { es: 'Crea un nuevo proyecto', en: 'Create a new project' },
  undo: { es: 'Deshacer', en: 'Undo' },
  redo: { es: 'Rehacer', en: 'Redo' },
  duplicateFurniture: { es: 'Duplicar mueble', en: 'Duplicate unit' },
  delete: { es: 'Eliminar', en: 'Delete' },
  group: { es: 'Grupo', en: 'Group' },
  groupOpen: { es: 'Grupo abierto', en: 'Group open' },
  groupClosed: { es: 'Grupo cerrado', en: 'Group closed' },
  unnamed: { es: 'Sin nombre', en: 'Unnamed' },
  loadingTextures: { es: 'Cargando texturas...', en: 'Loading textures...' },
  loadingFinishes: { es: 'Cargando acabados...', en: 'Loading finishes...' },
  loadingZones: { es: 'Cargando zonas...', en: 'Loading zones...' },
  loadingTextureGroups: {
    es: 'Cargando grupos de texturas...',
    en: 'Loading texture groups...',
  },
  noFinishes: { es: 'No hay acabados para este linkedItem', en: 'No finishes for this linked item' },
  date: { es: 'Fecha', en: 'Date' },
  model: { es: 'Modelo', en: 'Model' },
  characteristics: { es: 'Características', en: 'Characteristics' },
  reference: { es: 'Referencia', en: 'Reference' },
  fabric: { es: 'Tejido', en: 'Fabric' },
  fabricCharacteristics: { es: 'Características tejido:', en: 'Fabric characteristics:' },
  totalPrice: { es: 'Precio total:', en: 'Total price:' },
  total: { es: 'Total:', en: 'Total:' },
  print: { es: 'Imprimir', en: 'Print' },
  download: { es: 'Descargar', en: 'Download' },
  budget: { es: 'Presupuesto', en: 'Budget' },
  closeBudget: { es: 'Cerrar presupuesto', en: 'Close budget' },
  currentScene: { es: 'Escena actual', en: 'Current scene' },
  noCapture: { es: 'Sin captura disponible', en: 'No capture available' },
  withPhoto: { es: '(con su foto)', en: '(with its photo)' },
  dimLargo: { es: 'L', en: 'L' },
  dimFondo: { es: 'F', en: 'D' },
  dimAlto: { es: 'A', en: 'H' },
  budgetLargo: { es: 'largo', en: 'length' },
  budgetFondo: { es: 'fondo', en: 'depth' },
  budgetAlto: { es: 'alto', en: 'height' },
  catalogLargo: { es: 'Largo', en: 'Length' },
  catalogFondo: { es: 'Fondo', en: 'Depth' },
  catalogAlto: { es: 'Alto', en: 'Height' },
  and: { es: 'y', en: 'and' },
  options: { es: 'Opciones', en: 'Options' },
  cushions: { es: 'Cojines', en: 'Cushions' },
  rectangularCushions: { es: 'Cojines rectangulares', en: 'Rectangular cushions' },
  multiCushions: { es: 'Multicojines', en: 'Multi-cushions' },
  seatSingular: { es: 'Asiento', en: 'Seat' },
  seatPlural: { es: 'Asientos', en: 'Seats' },
  withStitch: { es: 'con costura', en: 'with stitching' },
  withoutStitch: { es: 'sin costura', en: 'without stitching' },
  cushionHeight: { es: 'Altura cojines', en: 'Cushion height' },
  chooseOptions: { es: 'Elegir opciones', en: 'Choose options' },
  depth: { es: 'Fondo', en: 'Depth' },
  armType: { es: 'Tipo de brazo', en: 'Arm type' },
  armTypeShort: { es: 'Tipo\nde brazo', en: 'Arm\ntype' },
  armTypeEmbedded: { es: 'Tipo\nbrazo', en: 'Arm\ntype' },
  cushionType: { es: 'Tipo de cojín', en: 'Cushion type' },
  cushionTypeShort: { es: 'Tipo\nde cojín', en: 'Cushion\ntype' },
  cushionTypeEmbedded: { es: 'Tipo\ncojín', en: 'Cushion\ntype' },
  seatStitchTab: { es: 'Asiento con/sin costura', en: 'Seat with/without stitching' },
  seatStitchTabShort: { es: 'Asiento con/sin\ncostura', en: 'Seat stitch\non/off' },
  seatStitchTabEmbedded: { es: 'Asiento\ncostura', en: 'Seat\nstitch' },
  seatHeightTab: { es: 'Altura Asiento', en: 'Seat height' },
  seatHeightTabEmbedded: { es: 'Altura\nasiento', en: 'Seat\nheight' },
  seatHeightAlt: { es: 'Altura', en: 'Height' },
  replaceByDepth: { es: 'Sustituir por fondo', en: 'Replace with depth' },
  replaceByHeight: { es: 'Reemplazar por esta altura', en: 'Replace with this height' },
  replaceByStitch: { es: 'Reemplazar por esta opción', en: 'Replace with this option' },
  replaceBySeatModel: {
    es: 'Reemplazar por este modelo de asiento',
    en: 'Replace with this seat model',
  },
  replaceByCushionModel: {
    es: 'Reemplazar por este modelo de cojín',
    en: 'Replace with this cushion model',
  },
  addNewArm: { es: 'Añadir nuevo brazo', en: 'Add new arm' },
  replaceArmVariant: {
    es: 'Sustituir variante de brazo (sin brazos → un lado → ambos → otro lado)',
    en: 'Replace arm variant (no arms → one side → both → other side)',
  },
  selectFreeEndUnit: {
    es: 'Selecciona la unidad recta (módulo) del extremo libre para colocar o quitar el brazo.',
    en: 'Select the straight unit (module) at the free end to place or remove the arm.',
  },
  noFreeEndForArm: {
    es: 'Esta unidad no tiene un extremo libre para colocar el brazo (ambos lados están ocupados).',
    en: 'This unit has no free end to place the arm (both sides are occupied).',
  },
  unitsSkipped: { es: 'Unidades omitidas:', en: 'Skipped units:' },
  armRestrictionTitle: { es: 'Restricción de brazos', en: 'Arm restriction' },
  accept: { es: 'Ok', en: 'Ok' },
  replace: { es: 'Reemplazar', en: 'Replace' },
  replaceArmsWithThis: { es: 'Reemplazar brazos por este', en: 'Replace arms with this' },
  withoutStitchLabel: { es: 'Sin costura', en: 'No stitching' },
  withStitchLabel: { es: 'Con costura', en: 'With stitching' },
  noTexturesAvailable: { es: 'No hay texturas disponibles', en: 'No textures available' },
  noTexturesForFamily: {
    es: 'No hay texturas para esta familia',
    en: 'No textures for this family',
  },
  noZonesAvailable: { es: 'No hay zonas disponibles', en: 'No zones available' },
  texture: { es: 'Textura', en: 'Texture' },
  artisan1: {
    es: 'Estructura 100% de madera maciza procedente de bosques sostenibles. NO se utiliza ni aglomerado ni derivados. Garantía de por vida.',
    en: '100% solid wood structure from sustainable forests. No chipboard or derivatives are used. Lifetime warranty.',
  },
  artisan2: {
    es: 'No desmontable, únicamente los brazos.',
    en: 'Not dismantlable, only the arms.',
  },
  artisan3: {
    es: 'Sistema de suspensión base mediante cinchas elásticas. Garantía 15 años.',
    en: 'Base suspension system with elastic webbing. 15-year warranty.',
  },
  artisan4: {
    es: 'Cojines brazo y respaldo rellenos de microfibra acrílica antialérgica reciclable Plumifill Eco®, NO mezclada con otros materiales. Garantía 5 años.',
    en: 'Arm and back cushions filled with recyclable hypoallergenic acrylic microfiber Plumifill Eco®, NOT mixed with other materials. 5-year warranty.',
  },
  artisan5: {
    es: 'Cojines de asiento relleno de espuma HR combinada con Plumifill Eco®.',
    en: 'Seat cushions filled with HR foam combined with Plumifill Eco®.',
  },
  artisan6: {
    es: 'Pies ocultos PVC. Opción: ruedas con sistema activo de freno, 10 cm de altura.',
    en: 'Hidden PVC feet. Option: castors with active braking system, 10 cm height.',
  },
  artisan7: {
    es: 'Totalmente desenfundable, cojines y estructura.',
    en: 'Fully removable covers, cushions and structure.',
  },
} as const satisfies Record<string, LocalizedText>

export type UiCopyKey = keyof typeof copy

export function ui(key: UiCopyKey): string {
  return pickLocalizedText(copy[key])
}

export function getDimensionAbbrevLabels() {
  return {
    largo: ui('dimLargo'),
    fondo: ui('dimFondo'),
    alto: ui('dimAlto'),
  }
}

export function getBudgetDimensionWordLabels() {
  return {
    largo: ui('budgetLargo'),
    fondo: ui('budgetFondo'),
    alto: ui('budgetAlto'),
  }
}

/** Etiquetas del menú: Largo/Fondo/Alto (ES) o Length/Depth/Height (EN). */
export function getCatalogDimensionLabels() {
  return {
    largo: ui('catalogLargo'),
    fondo: ui('catalogFondo'),
    alto: ui('catalogAlto'),
  }
}

export function getArtisanCharacteristics(): string[] {
  return [
    ui('artisan1'),
    ui('artisan2'),
    ui('artisan3'),
    ui('artisan4'),
    ui('artisan5'),
    ui('artisan6'),
    ui('artisan7'),
  ]
}
